import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { Card, Col, Row } from "reactstrap";
import { ReactComponent as Raindrops } from "../../assets/uicons-regular-rounded/svg/fi-rr-raindrops.svg";
import { ReactComponent as Apple } from "../../assets/uicons-regular-rounded/svg/fi-rr-apple.svg";
import { ReactComponent as Syringe } from "../../assets/uicons-regular-rounded/svg/fi-rr-syringe.svg";
import { ReactComponent as DarkSyringe } from "../../assets/uicons-solid-rounded/svg/fi-sr-syringe.svg";
import SplineAreaChart from "../Charts/SplineAreaChart";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Loading from "../../assets/uxnicon/loadingIcon.png";
import moment from "moment";
import "moment/locale/ko";
import {
  percentData,
  userID,
  agpData,
  appointments,
} from "../../states/recoilState";
import "./bloodsugar.scss";
import PrintScreenPagecopy from "./PrintScreenPagecopy";
import { useReactToPrint } from "react-to-print";
const DailyPattern = () => {
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(moment().subtract(1, "d"));
  const idx = useRecoilValue(userID);
  const [charts, setCharts] = useState({});
  const [agps, setAgps] = useState({});
  const appointdata = useRecoilValue(appointments);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <React.Fragment>
      <div className="wrap" ref={componentRef}>
        <button
          type="button"
          className="bg-gray-500 border border-gray-500 p-2 mb-4 printHIdeBtn"
          onClick={handlePrint}
          style={{
            position: "absolute",
            top: "130px",
            right: "25px",
            backgroundColor: "#5b5d5f",
            color: "#fff",
            borderRadius: "8px",
          }}
        >
          {" "}
          Print{" "}
        </button>
        {!loading ? (
          <div
            className="divsWrap"
            style={{ padding: "36px 147px 114px 168px" }}
          >
            <div className="m-0 p-0 w-100 row">
              <div className="m-0 p-0 col">
                <div className="m-0 p-0 w-100 row d-flex flex-column">
                  <div className="m-0 p-0 col">
                    <p className="m-0 fs-6" style={{ color: "#2A2D30" }}>
                      {idx.patientName}
                    </p>
                  </div>
                  <div
                    className="m-0 p-0 col d-flex"
                    style={{ alignItems: "baseline" }}
                  >
                    <p
                      style={{
                        fontSize: "10px",
                        color: "#2A2D30",
                        margin: "0px 9px 0px 0px",
                      }}
                    >
                      DOB:
                    </p>
                    <p
                      className="m-0"
                      style={{ fontSize: "15px", color: "#2A2D30" }}
                    >
                      {idx.patientBirth}
                    </p>
                  </div>
                </div>
              </div>
              <div className="m-0 p-0 col">
                <div className="m-0 p-0 w-100 row d-flex flex-column">
                  <div
                    className="m-0 p-0 col d-flex"
                    style={{ alignItems: "baseline" }}
                  >
                    <p
                      style={{
                        fontSize: "10px",
                        color: "#2A2D30",
                        margin: "0px 9px 0px 0px",
                      }}
                    >
                      MRN :
                    </p>
                    <p
                      className="m-0 fs-6"
                      style={{ fontSize: "15px", color: "#2A2D30" }}
                    ></p>
                  </div>
                  <div
                    className="m-0 p-0 col d-flex"
                    style={{ alignItems: "baseline" }}
                  >
                    <p
                      style={{
                        fontSize: "10px",
                        color: "#2A2D30",
                        margin: "0px 9px 0px 0px",
                      }}
                    >
                      장치 :
                    </p>
                    <p
                      className="m-0"
                      style={{ fontSize: "15px", color: "#2A2D30" }}
                    >
                      AGMS T1x
                    </p>
                  </div>
                </div>
              </div>
              <div className="m-0 p-0 col"></div>
            </div>
            <div className="m-0 p-0 w-100 row">
              <div
                className="m-0 p-0 col fs-2 fw-bold"
                style={{ color: "#2A2D30" }}
              >
                혈당 패턴 정보
              </div>
            </div>
            <div
              className="p-0 w-100 row"
              style={{ margin: "0px 0px 17px 0px" }}
            >
              <div className="m-0 p-0 col" style={{ color: "#2A2D30" }}>
                {moment(charts?.startDate).format("YYYY년MM월DD일")} ~{" "}
                {moment(charts?.endDate).format("YYYY년MM월DD일")} (
                {agps?.dateRange}일)
              </div>
            </div>
            <div className="m-0 p-0 w-100 row justify-content-between">
              <div className="m-0 col-12">
                {/* <div
                  className="fs-6 fw-bold"
                  style={{
                    color: "#fff",
                    backgroundColor: "#000000",
                    padding: "4px 8px",
                  }}
                >
                  범위 내 시간
                </div> */}
                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: "33px" }}
                >
                  <div className="w-100">
                    <Row>
                      <div
                        className="snapTitleLineWrap"
                        style={{ marginBottom: "21px" }}
                      >
                        <Raindrops className="icons" />
                        <span className="iconsTitle" style={{ width: "70px" }}>
                          혈당
                        </span>
                        <div className="titleLine" />
                      </div>
                      <Col>
                        <Card
                          className="bloodSugarSubTotalCard"
                          style={{
                            height: "651px",
                          }}
                        >
                          <div style={{ height: "100%" }}>
                            <SplineAreaChart />
                          </div>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <div
                        className="snapTitleLineWrap"
                        style={{ marginBottom: "21px" }}
                      >
                        <Apple className="icons" />
                        <span className="iconsTitle" style={{ width: "120px" }}>
                          탄수화물
                        </span>
                        <div className="titleLine" />
                      </div>
                      <Col>
                        <Card
                          className="bloodSugarSubTotalCard"
                          style={{
                            height: "535px",
                          }}
                        >
                          <div style={{ height: "100%" }}>
                            <SplineAreaChart />
                          </div>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <div
                        className="snapTitleLineWrap"
                        style={{ marginBottom: "21px" }}
                      >
                        <DarkSyringe className="icons" />
                        <span className="iconsTitle" style={{ width: "210px" }}>
                          초속효성 인슐린
                        </span>
                        <div className="titleLine" />
                      </div>
                      <Col>
                        <Card
                          className="bloodSugarSubTotalCard"
                          style={{
                            height: "535px",
                          }}
                        >
                          <div style={{ height: "100%" }}>
                            <SplineAreaChart />
                          </div>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <div
                        className="snapTitleLineWrap"
                        style={{ marginBottom: "21px" }}
                      >
                        <Syringe className="icons" />
                        <span className="iconsTitle" style={{ width: "180px" }}>
                          지속형 인슐린
                        </span>
                        <div className="titleLine" />
                      </div>
                      <Col>
                        <Card
                          className="bloodSugarSubTotalCard"
                          style={{
                            height: "535px",
                          }}
                        >
                          <div style={{ height: "100%" }}>
                            <SplineAreaChart />
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="divsWrap"
            style={{
              padding: "36px 147px",
              position: "absolute",
              left: 0,
              top: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 10001,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={Loading}
                alt="loading..."
                style={{
                  width: "50px",
                  height: "50px",
                  animation: ".75s linear infinite spinner-border",
                }}
              />
            </div>
          </div>
        )}
      </div>
      <PrintScreenPagecopy
        setCharts={setCharts}
        charts={charts}
        setAgps={setAgps}
        agps={agps}
        setLoading={setLoading}
      />
    </React.Fragment>
  );
};
export default withRouter(DailyPattern);
